//      
import * as keyCodes from '../../../key-codes';

               
                      
  

const preventedKeys         = {
  // submission
  [keyCodes.enter]: true,
  // tabbing
  [keyCodes.tab]: true,
};

export default (event               ) => {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-sensor-marshal/sensors/util/prevent-standard-key-events.js